export const PRECACHE_FILES_COUNT = 404;
